import { useCallback } from "react";
import axios from "axios";
import { useQuery } from "react-query";

import {
  AgilisysSignUpModalUrl,
  inspireMembershipCategoryListUrl,
  inspireMembershipIntroductionUrl,
  inspireMembershipLifestyleEventsDetailUrl,
  inspireMembershipLifestyleEventsUrl,
  inspireMembershipOfferRecommendationUrl,
  inspireMembershipTermsConditionsUrl,
  inspireMembershipTiersBenefitsUrl,
  myProfileUrl,
} from "./apiUrls";
import { LOCAL_STORAGE_LANGUAGE } from "./static-data";

// InspireMembership.jsx
export function useGetInspireMembershipOfferRecommendation() {
  const language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const getInspireMembershipOfferRecommendation = useCallback(async () => {
    const { status, data } = await axios.get(
      `${inspireMembershipOfferRecommendationUrl}?language=${language}`
    );

    if (status === 200) {
      return data[0];
    }
  }, [language]);

  return useQuery(
    ["inspireMembershipOfferRecommendation", language],
    getInspireMembershipOfferRecommendation,
    {
      notifyOnChangeProps: "tracked",
    }
  );
}

// InspireMembership.jsx
export function useGetInspireMembershipIntroduction() {
  const language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const getInspireMembershipIntroduction = useCallback(async () => {
    const { status, data } = await axios.get(
      `${inspireMembershipIntroductionUrl}?language=${language}`
    );

    if (status === 200) {
      return data[0];
    }
  }, [language]);

  return useQuery(
    ["inspireMembershipIntroduction", language],
    getInspireMembershipIntroduction,
    {
      notifyOnChangeProps: "tracked",
    }
  );
}

// InspireMembershipTiers.jsx
export function useGetInspireMembershipTiersBenefits() {
  const language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const getInspireMembershipTiersBenefits = useCallback(async () => {
    const { status, data } = await axios.get(
      `${inspireMembershipTiersBenefitsUrl}?language=${language}`
    );

    if (status === 200) {
      return data[0];
    }
  }, [language]);

  return useQuery(
    ["inspireMembershipTiersBenefits", language],
    getInspireMembershipTiersBenefits,
    {
      notifyOnChangeProps: "tracked",
    }
  );
}

// InspireMembershipTiers.jsx
export function useGetInspireMembershipCategoryList() {
  const language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const getInspireMembershipCategoryList = useCallback(async () => {
    const { status, data } = await axios.get(
      `${inspireMembershipCategoryListUrl}&language=${language}`
    );

    if (status === 200) {
      return data;
    }
  }, [language]);

  return useQuery(
    ["inspireMembershipCategoryList", language],
    getInspireMembershipCategoryList,
    {
      notifyOnChangeProps: "tracked",
    }
  );
}

// InspireMembershipLifestyleList.jsx
export function useGetInspireMembershipLifestyleEvents() {
  const language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const getInspireMembershipLifestyleEvents = useCallback(async () => {
    const { status, data } = await axios.get(
      `${inspireMembershipLifestyleEventsUrl}?language=${language}`
    );

    if (status === 200) {
      return data[0];
    }
  }, [language]);

  return useQuery(
    ["inspireMembershipLifestyleEvents", language],
    getInspireMembershipLifestyleEvents,
    {
      notifyOnChangeProps: "tracked",
    }
  );
}

// InspireMembershipLifestyleItemList.jsx
export function useGetInspireMembershipLifestyleEventsItems() {
  const language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const getInspireMembershipLifestyleEventsItems = useCallback(async () => {
    const { status, data } = await axios.get(
      `${inspireMembershipLifestyleEventsDetailUrl}?language=${language}`
    );

    if (status === 200) {
      return data;
    }
  }, [language]);

  return useQuery(
    ["inspireMembershipLifestyleEventsDetail", language],
    getInspireMembershipLifestyleEventsItems,
    {
      notifyOnChangeProps: "tracked",
    }
  );
}

// InspireMembershipLifestyleDetail.jsx
export function useGetInspireMembershipLifestyleEventsDetail(uuid) {
  const language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const getInspireMembershipLifestyleEventsDetail = useCallback(async () => {
    const { status, data } = await axios.get(
      `${inspireMembershipLifestyleEventsDetailUrl}?language=${language}&uuid=${uuid}`
    );

    if (status === 200) {
      return data[0];
    }
  }, [language, uuid]);

  return useQuery(
    ["inspireMembershipLifestyleEventsDetail", language, uuid],
    getInspireMembershipLifestyleEventsDetail,
    {
      notifyOnChangeProps: "tracked",
    }
  );
}

// AgilisysSignUp.jsx
export function useGetAgilisysSignUp() {
  const language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const getAgilisysSignUp = useCallback(async () => {
    const { status, data } = await axios.get(
      `${AgilisysSignUpModalUrl}?language=${language}`
    );

    if (status === 200) {
      return data[0];
    }
  }, [language]);

  return useQuery(["AgilisysSignUp", language], getAgilisysSignUp, {
    enabled: !!language,
  });
}

// MyProfile.jsx
export function useGetMyProfile() {
  const language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const getMyProfile = useCallback(async () => {
    const { status, data } = await axios.get(
      `${myProfileUrl}?language=${language}`
    );

    if (status === 200) {
      return data[0];
    }
  }, [language]);

  return useQuery(["myProfile", language], getMyProfile, {
    enabled: !!language,
  });
}

export function useGetInspireMembershipTermsConditions() {
  const language = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const getInspireMembershipTermsConditions = useCallback(async () => {
    const { status, data } = await axios.get(
      `${inspireMembershipTermsConditionsUrl}?language=${language}`
    );

    if (status === 200) {
      return data[0];
    }
  }, [language]);

  return useQuery(
    ["inspireMembershipTermsConditions", language],
    getInspireMembershipTermsConditions,
    {
      notifyOnChangeProps: "tracked",
    }
  );
}
